<template>
  <span>
    <v-autocomplete dense v-bind:value="value" :disabled="disabled" :auto-select-first="autoSelectFirst" v-on:input="onInput" :rules="rules" :items="data.items" :loading="data.isLoading" :search-input.sync="data.search" item-text="code" item-value="_id" no-data :no-data-text="'- type to find -'" clearable @focus="onFocus" @change="onInput" :no-filter="true" return-object multiple :required="required" :hint="hint" :persistent-hint="hint ? true : false" flat hide-details :placeholder="placeholder"></v-autocomplete>
  </span>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import {debounce} from "./../../../libs/debounce"
import eventBus from "../../../eventBus"
import {streetService} from "./service"
import {rules} from "./../../../libs/utils"

@Component({
  components: {},
})
export default class StreetSelect extends Vue {
  @Prop({default: () => []})
  rules

  @Prop()
  canton //filter locations by canton

  @Prop({default: null})
  locname

  @Prop({default: false})
  autoSelectFirst

  @Prop({default: false})
  allowNew

  @Prop()
  value

  @Prop()
  required

  @Prop()
  disabled

  @Prop({default: "Street"})
  label

  @Prop({default: null})
  hint

  @Prop()
  siteID

  @Prop()
  placeholder

  data: any = {
    items: [],
    isLoading: false,
    search: null,
    itemsLoaded: false,
    locname: null,
    canton: null,
  }

  async created() {
    this.data.locname = this.locname
    this.data.canton = this.canton
    if (this.value && this.value.length > 0) {
      Vue.set(this.data, "items", this.value)
    }
  }

  onInput(val) {
    this.$emit("input", val)
  }

  async onFocus() {
    if (!this.value || this.value.length == 0) {
      this.loadItems()
    }
  }

  @Watch("canton")
  onCantonSet(val) {
    console.log("set canton", val)
    this.data.canton = val
    this.loadItems()
  }
  @Watch("locname")
  onLocNameSet(val) {
    console.log("set locname", val)
    this.data.locname = val
    this.loadItems()
  }

  @Watch("value")
  onValueSet(val) {
    if ((!this.value || this.value.length == 0) && this.data.itemsLoaded == false) {
      this.loadItems()
    }
  }

  @Watch("data.search")
  find(val) {
    debounce.delay(() => {
      this.loadItems()
    }, 450)
  }

  async loadItems() {
    if (this.data.isLoading) {
      return
    }
    this.data.isLoading = true
    console.log("loadItems STR canton preset as ", this.canton, this.locname)
    let payload = {
      q: this.data.search,
      canton: this.canton ? this.canton.code : null,
      locname: this.data.locname ? this.data.locname.map((i) => i.code) : null,
    }
    try {
      let options = {fields: "code,canton,locname", limit: 250}
      let res = await streetService.find(payload, options)
      if (res.error == true || res.data == null) {
        eventBus.$emit("display-snackbar", {type: "error", text: "Failed to load items. Please check your internet connection and try again"})
        this.data.isLoading = false
        return
      }

      this.data.items = res.data.sort((a, b) => a.code.localeCompare(b.code))
      this.data.isLoading = false
      this.data.itemsLoaded = true
    } catch (error) {
      console.log(error)
      this.data.isLoading = false
    }
  }
}
</script>
